import { useState } from 'react'
import clsx from 'clsx'
import { Admin } from '../types'
import './ProfileImage.css'

interface ProfileImageProps {
    admin: Admin
    size?: 'small' | 'regular'
}

export const ProfileImage = ({ admin, size = 'regular' }: ProfileImageProps) => {
    const [imgError, setImgError] = useState(false)
    const initials = (admin.first_name?.charAt(0) ?? '') + (admin.last_name?.charAt(0) ?? '')

    return (
        <div className={clsx('profile-image', size)}>
            {admin.image_url && !imgError
                ? <img
                    src={admin.image_url}
                    referrerPolicy="no-referrer"
                    onError={() => setImgError(true)}
                />
                : <span className="profile-image-initials">{initials.toUpperCase()}</span>
            }
        </div>
    )
}
